/** Analyst Shadow 판단 차이 관찰 리포트 API. */
import { apiFetch } from '../utils/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export interface AnalystLearningReport {
  generated_at: string;
  mode: 'read_only';
  days: number;
  window: { start: string; end: string; basis: string };
  summary: {
    rule_count: number;
    shadow_count: number;
    paired_count: number;
    pending_count: number;
    pairing_coverage: number;
    disagreement_rate: number;
    sample_ok: boolean;
    sample_threshold: number;
    outcome_status: string;
  };
  auto_backfill: {
    enabled: boolean;
    batch_size: number;
    daily_row_limit: number;
    today_processed_count: number;
    today_remaining: number;
    last_shadow_at: string | null;
  };
  agreement: Record<'agree' | 'disagree' | 'mixed' | 'unknown', number>;
  action_matrix: AnalystActionMatrixItem[];
  direction_split: AnalystDirectionItem[];
  flags: AnalystPatternFlag[];
  latest_pairs: AnalystPairItem[];
  non_goals: string[];
}

export interface AnalystActionMatrixItem {
  rule_action: string;
  analyst_action: string;
  count: number;
}

export interface AnalystDirectionItem extends AnalystActionMatrixItem {
  label: string;
}

export interface AnalystPatternFlag {
  key: string;
  name: string;
  transition: string;
  count: number;
  ratio: number;
  severity: 'observation' | 'caution' | 'deferred';
  sample_warning: string;
}

export interface AnalystPairItem {
  rule_id: number;
  shadow_id: number;
  symbol: string;
  rule_timestamp: string | null;
  shadow_timestamp: string | null;
  rule_action: string;
  analyst_action: string;
  agreement: string;
  weighted_total: number;
  rule_confidence: number;
  analyst_confidence: number;
  reasons: string[];
  counterarguments: string[];
  invalidation_condition: string;
}

export async function fetchAnalystLearningReport(days = 7): Promise<AnalystLearningReport> {
  const response = await apiFetch(`${API_BASE_URL}/api/analyst-learning/weekly?days=${days}`);
  if (!response.ok) {
    throw new Error(`Analyst Shadow 관찰 조회 실패: ${response.status}`);
  }
  return response.json();
}
